import React, { Component } from 'react';
import Products from './components/Products';
import Cart from './components/Cart';
import { Route, Switch, Link, BrowserRouter as Router } from 'react-router-dom';
import ScrollToTop from './ScrollToTop';

import Header from './Header.js';
import Product from './routes/Product';


class App extends Component {
  constructor() {
    super();

    this.state = {
      isCartOpen: false,
      checkout: { lineItems: [] },
      products: [],
      shop: {}
    };

    this.handleCartClose = this.handleCartClose.bind(this);
    this.addVariantToCart = this.addVariantToCart.bind(this);
    this.updateQuantityInCart = this.updateQuantityInCart.bind(this);
    this.removeLineItemInCart = this.removeLineItemInCart.bind(this);
  }

  componentWillMount() {
    this.props.client.checkout.create().then((res) => {
      this.setState({
        checkout: res,
      });
    });

    this.props.client.product.fetchAll().then((res) => {
      this.setState({
        products: res,
      });
    });

    this.props.client.shop.fetchInfo().then((res) => {
      this.setState({
        shop: res,
      });
    });
  }

  addVariantToCart(variantId, quantity){
    this.setState({
      isCartOpen: true,
    });

    const lineItemsToAdd = [{variantId, quantity: parseInt(quantity, 10)}]
    const checkoutId = this.state.checkout.id

    return this.props.client.checkout.addLineItems(checkoutId, lineItemsToAdd).then(res => {
      this.setState({
        checkout: res,
      });
    });
  }

  updateQuantityInCart(lineItemId, quantity) {
    const checkoutId = this.state.checkout.id
    const lineItemsToUpdate = [{id: lineItemId, quantity: parseInt(quantity, 10)}]

    return this.props.client.checkout.updateLineItems(checkoutId, lineItemsToUpdate).then(res => {
      this.setState({
        checkout: res,
      });
    });
  }

  removeLineItemInCart(lineItemId) {
    const checkoutId = this.state.checkout.id

    return this.props.client.checkout.removeLineItems(checkoutId, [lineItemId]).then(res => {
      this.setState({
        checkout: res,
      });
    });
  }

  handleCartClose() {
    this.setState({
      isCartOpen: false,
    });
  }
  
  render() {
    return (
      <div className="App">
        <Router>
          <ScrollToTop />
          <Switch>
            <Route exact path="/">
              <div>
                <Header headerType="home" onClick={()=> this.setState({isCartOpen: true})}></Header>
                <div className="App__title">
                  <h2>Handmade, minimalistic ceramics.</h2>
                  <span>Made in sunny San Francisco, CA.</span>
                </div>
                <Products
                  products={this.state.products}
                  client={this.props.client}
                  addVariantToCart={this.addVariantToCart}
                />
              </div>
            </Route>/>
            <Route path="/products/:slug">
              <div>
                <Header headerType="slim" onClick={()=> this.setState({isCartOpen: true})}></Header>
                <Product client={this.props.client} addVariantToCart={this.addVariantToCart}/>
              </div>
            </Route>
          </Switch>
        </Router>
        
        <Cart
          checkout={this.state.checkout}
          isCartOpen={this.state.isCartOpen}
          handleCartClose={this.handleCartClose}
          updateQuantityInCart={this.updateQuantityInCart}
          removeLineItemInCart={this.removeLineItemInCart}
        />
        <footer className="site-footer">
          Some stuff in the footer
        </footer>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js